import HowToWatch from './HowToWatch';

export default HowToWatch;